import * as types from '../types/authorTypes';

const initialState = {
  loadingProfile: false,
  loadingArticles: false,
  authors: [],
  author: null,
  authorArticles: [],
  authorFilters: {
    categories: [],
  },
  pagination: {
    page: 1,
    limit: 9,
    total: 0,
    pages: 0,
  },
  error: null,
};

const authorReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH AUTHORS
    case types.FETCH_AUTHORS_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        error: null,
      };
    case types.FETCH_AUTHORS_SUCCESS:
      return {
        ...state,
        loadingProfile: false,
        authors: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        error: null,
      };
    case types.FETCH_AUTHORS_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        error: action.payload,
      };

    // FETCH AUTHOR BY SLUG
    case types.FETCH_AUTHOR_BY_SLUG_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        error: null,
        author: null,
        authorArticles: [],
        authorFilters: { categories: [] },
        pagination: {
          page: 1,
          limit: state.pagination.limit,
          total: 0,
          pages: 0,
        },
      };
    case types.FETCH_AUTHOR_BY_SLUG_SUCCESS:
      return {
        ...state,
        loadingProfile: false,
        author: action.payload.data || action.payload,
        error: null,
      };
    case types.FETCH_AUTHOR_BY_SLUG_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        author: null,
        error: action.payload,
      };

    // FETCH AUTHOR ARTICLES
    case types.FETCH_AUTHOR_ARTICLES_REQUEST:
      return {
        ...state,
        loadingArticles: true,
        error: null,
      };
    case types.FETCH_AUTHOR_ARTICLES_SUCCESS: {
      const payload = action.payload || {};
      return {
        ...state,
        loadingArticles: false,
        authorArticles: payload.data || [],
        authorFilters: {
          categories: payload.filters?.categories || [],
        },
        pagination: {
          page: payload.page || 1,
          limit: payload.limit || state.pagination.limit,
          total: payload.total || 0,
          pages: payload.pages || 0,
        },
        error: null,
      };
    }
    case types.FETCH_AUTHOR_ARTICLES_FAILURE:
      return {
        ...state,
        loadingArticles: false,
        error: action.payload,
      };

    // CREATE AUTHOR
    case types.CREATE_AUTHOR_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        error: null,
      };
    case types.CREATE_AUTHOR_SUCCESS:
      return {
        ...state,
        loadingProfile: false,
        authors: [...state.authors, action.payload.data || action.payload],
        error: null,
      };
    case types.CREATE_AUTHOR_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        error: action.payload,
      };

    // UPDATE AUTHOR
    case types.UPDATE_AUTHOR_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        error: null,
      };
    case types.UPDATE_AUTHOR_SUCCESS: {
      const updatedAuthor = action.payload.data || action.payload;
      return {
        ...state,
        loadingProfile: false,
        authors: state.authors.map((author) =>
          author._id === updatedAuthor._id ? updatedAuthor : author
        ),
        author: state.author?._id === updatedAuthor._id ? updatedAuthor : state.author,
        error: null,
      };
    }
    case types.UPDATE_AUTHOR_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        error: action.payload,
      };

    // DELETE AUTHOR
    case types.DELETE_AUTHOR_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        error: null,
      };
    case types.DELETE_AUTHOR_SUCCESS:
      return {
        ...state,
        loadingProfile: false,
        authors: state.authors.filter((author) => author._id !== action.payload),
        error: null,
      };
    case types.DELETE_AUTHOR_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default authorReducer;


